import React, { useState } from 'react';
import styled from 'styled-components';
import Star from '../icons/line/Star';
import HalfStrokedStar from '../icons/line/FavoriteHalf';
import SolidStar from '../icons/solid/Favorite';
import HalfSolidStar from '../icons/solid/FavoriteHalf';
import withSpacing from '../lib/hoc/withSpacing';
import { Icon } from './Icon';
const FlippedIcon = styled(Icon).withConfig({
  displayName: "Rating__FlippedIcon",
  componentId: "sc-1j006f9-0"
})(["transform:scaleX(-1) translateX(100%);"]);
const FlippedIconWrapper = styled.div.withConfig({
  displayName: "Rating__FlippedIconWrapper",
  componentId: "sc-1j006f9-1"
})(["display:inline-block;margin-right:", ";"], x => `calc(-1 * ${x.$iconWidth})`);

const RatingFunc = ({
  fillColor = 'yellow',
  filledIcon = SolidStar,
  iconWidth = '1.5em',
  maxRating = 5,
  minRating = 1,
  onRatingChange,
  rating,
  readOnly = false,
  strokeColor = 'yellow',
  strokedIcon = Star,
  useOwnState = false,
  useHalfStars = true
}) => {
  const [ratingState, setRatingState] = useState(rating);

  const onStarClicked = position => {
    if (readOnly) return;

    if (position >= minRating || position <= maxRating) {
      if (useOwnState) setRatingState(position);else onRatingChange(position);
    }
  }; // TODO: Allow setting half star ratings optionally


  const showHalfStar = readOnly && useHalfStars;
  const ratingToShow = useOwnState ? ratingState : rating;
  const filledStars = [...Array(Math.floor(ratingToShow))];
  const stokedStars = [...Array(maxRating - (showHalfStar ? Math.ceil(ratingToShow) : Math.floor(ratingToShow)))];
  const HalfStar = showHalfStar && ratingToShow > Math.floor(ratingToShow) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
    icon: HalfSolidStar,
    fill: fillColor,
    width: iconWidth,
    ml: "3px"
  }), /*#__PURE__*/React.createElement(FlippedIconWrapper, {
    $iconWidth: iconWidth
  }, /*#__PURE__*/React.createElement(FlippedIcon, {
    icon: HalfStrokedStar,
    stroke: strokeColor,
    width: iconWidth
  })));
  return /*#__PURE__*/React.createElement(React.Fragment, null, filledStars.map((_, index) => /*#__PURE__*/React.createElement(Icon, {
    key: `star-${index}`,
    icon: filledIcon,
    fill: fillColor,
    onClick: () => onStarClicked(index + 1),
    width: iconWidth,
    ml: index > 0 ? '3px' : 0
  })), HalfStar, stokedStars.map((_, index) => /*#__PURE__*/React.createElement(Icon, {
    key: `star-${index}`,
    icon: strokedIcon,
    stroke: strokeColor,
    onClick: () => onStarClicked(filledStars.length + index + 1),
    width: iconWidth,
    ml: ratingToShow > 0 ? '3px' : 0
  })));
};

export const Rating = withSpacing(RatingFunc);